const isBrowser =
  typeof window !== 'undefined' && typeof navigator !== 'undefined';

const isIOS = isBrowser && /iP(hone|ad|od)/.test(navigator.userAgent);
const isSafari =
  isBrowser &&
  /Safari/.test(navigator.userAgent) &&
  !/Chrome/.test(navigator.userAgent);

const preventScroll = () => {
  if (!isBrowser) return;

  document.body.style.overflow = 'hidden';

  if (isIOS && isSafari) {
    const scrollY = window.scrollY;

    document.body.style.width = '100%';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
  }
};

const allowScroll = () => {
  if (!isBrowser) return;

  document.body.style.overflow = '';

  if (isIOS && isSafari) {
    const scrollY = parseInt(document.body.style.top || '0', 10);

    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.position = '';

    window.scrollTo(0, -scrollY);
  }
};

export { preventScroll, allowScroll };
